export default function useRevenueKPIAccess() {
  return true
}
